<script setup>
import {computed, watch} from "vue";
import Select from "primevue/select";
import FloatLabel from "primevue/floatlabel";
import {useVuelidate} from "@vuelidate/core";
import {required} from "@vuelidate/validators";

// Props
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'add'
  }
})

// Emits
const emit = defineEmits(['update:modelValue'])

// Local state (two-way binding)
const state = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

// States and colors
const states = computed(() => props.type === 'edit' ? ['New', 'Delivering', 'Delivered', 'Canceled', 'Paid'] : ['New'])
const stateColorsMap = {
  New: 'bg-[#9E9E9E]',
  Delivering: 'bg-[#FF9800]',
  Delivered: 'bg-[#2196F3]',
  Canceled: 'bg-[#F44336]',
  Paid: 'bg-[#4CAF50]',
}

// Validation
const rules = computed(() => ({
  state: {required}
}))
const $v = useVuelidate(rules, {state});

// Watch for change (emit event if you want extra event)
/*watch(state, (val) => {
  emit('update:modelValue', val)
})*/
</script>

<template>
  <div class="col-span-6 flex flex-col gap-0.5 w-full">
    <FloatLabel
        class="w-full custom-select"
        :class="{ 'has-error': $v.state.$error }"
        variant="on"
    >
      <Select
          v-model="state"
          inputId="state"
          :options="states"
          class="w-full min-w-28 !bg-transparent h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm"
          :class="[$v.state.$error ? '!border !border-red-300' : '!border-slate-700']"
          input-class="!py-1 !items-center !flex !pr-0"
          overlay-class="select-overlay-in-modal h-max"
      >
        <template #value="slotProps">
          <div class="flex items-center gap-2 !text-xs">
            <span class="w-2 h-2 rounded-full" :class="stateColorsMap[slotProps.value]"/>
            {{ slotProps.value }}
          </div>
        </template>

        <template #option="slotProps">
          <div class="flex items-center gap-2 !text-xs 2xl:!text-sm">
            <span class="w-2 h-2 rounded-full" :class="stateColorsMap[slotProps.option]"/>
            {{ slotProps.option }}
          </div>
        </template>
      </Select>
    </FloatLabel>

    <p v-if="$v.state.$error" class="text-red-300 mt-0.5 2xl:mt-1 text-[.6rem] 2xl:text-xs">
      This field is required
    </p>
  </div>
</template>
